module.exports = __webpack_public_path__ + "images/backgrounds/dew/large.5b5f4c5cd0d7e144e401.jpg";